import React, { Component } from 'react';
import {connect} from 'react-redux';
import * as actionCreators from '../../store/actionCreators';
import * as actionTypes from "../../store/actions";
import AdvisorAuth from "../../services/AdvisorAuth";

class Ria extends Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.isAuthorized) {
            // this.props.history.push("/annuityCalculator");
            this.props.history.push("/introduction");
        }
    }


    componentDidMount() {

        console.log(this.props.isAuthorized);

        if (!this.props.isAuthorized) {
            let qstring = this.props.location.search;
            let pair = qstring.split("=");
            let token = pair[1];

            this.props.login(token);
            this.props.setCompanyName();
            AdvisorAuth.setInstitute("GAIG");
        }

    }

    render() {
        return (
            <div>
                You are not authorized to view this page.
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthorized: state.globalState.isAuthorized
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        login: () => dispatch(actionCreators.loginAsCompany(
            "ria@riagaig.com",
            "Financial Advisors",
            "RIAGAIG",
            "RIAGAIG",
            1)),
        setCompanyName: () => dispatch({
            type: actionTypes.SET_COMPANY_NAME,
            value: "GAIG"
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (Ria);


// WEBPACK FOOTER //
// ./src/containers/Start/Ria.js